'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_presto$002eutils$0024$002dChange$002dSet from "./presto.utils$-Change-Set.js";
var $p;
/** @constructor */
function $c_Lpresto_ItemSelector(items, selected, changes, filtered, filters) {
  this.Xf = null;
  this.wW = null;
  this.wT = null;
  this.wU = null;
  this.wV = null;
  this.q4 = null;
  this.a89 = null;
  this.Xe = null;
  this.Xf = items;
  this.wW = selected;
  this.wT = changes;
  this.wU = filtered;
  this.wV = filters;
  this.q4 = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lcom_raquo_laminar_api_package$().a.a4.a6(items.a3(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sjsr_AnonFunction1(((_$15) => _$15.csr()))));
  this.a89 = selected.aZ().q();
  this.Xe = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lcom_raquo_airstream_core_BaseObservable__distinct__Lcom_raquo_airstream_core_Observable($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$ct_Lcom_raquo_airstream_misc_MapSignal__Lcom_raquo_airstream_core_Signal__F1__s_Option__(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lcom_raquo_airstream_misc_MapSignal(), selected, new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sjsr_AnonFunction1(((seq) => new $j_presto$002eutils$0024$002dChange$002dSet.$c_Lpresto_utils$ChangeSet(seq.b1(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sjsr_AnonFunction1(((item) => (!this.a89.aE(item))))), this.a89.b1(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sjsr_AnonFunction1(((seq$2) => ((item$2) => (!seq$2.aE(item$2))))(seq))), seq))), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_s_None$()));
}
export { $c_Lpresto_ItemSelector as $c_Lpresto_ItemSelector };
$p = $c_Lpresto_ItemSelector.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_ItemSelector;
/** @constructor */
function $h_Lpresto_ItemSelector() {
}
export { $h_Lpresto_ItemSelector as $h_Lpresto_ItemSelector };
$h_Lpresto_ItemSelector.prototype = $p;
$p.x = (function() {
  return new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_s_Product$$anon$1(this);
});
$p.p = (function() {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_s_util_hashing_MurmurHash3$().S(this, (-889275714), false);
});
$p.i = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lpresto_ItemSelector)) {
    var x = this.Xf;
    var x$2 = x$0.Xf;
    if (((x === null) ? (x$2 === null) : x.i(x$2))) {
      var x$3 = this.wW;
      var x$4 = x$0.wW;
      var $x_3 = (x$3 === x$4);
    } else {
      var $x_3 = false;
    }
    if ($x_3) {
      var x$5 = this.wT;
      var x$6 = x$0.wT;
      var $x_2 = (x$5 === x$6);
    } else {
      var $x_2 = false;
    }
    if ($x_2) {
      var x$7 = this.wU;
      var x$8 = x$0.wU;
      var $x_1 = (x$7 === x$8);
    } else {
      var $x_1 = false;
    }
    if ($x_1) {
      var x$9 = this.wV;
      var x$10 = x$0.wV;
      return ((x$9 === null) ? (x$10 === null) : x$9.i(x$10));
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$p.l = (function() {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_ScalaRunTime$().H(this);
});
$p.r = (function() {
  return 5;
});
$p.s = (function() {
  return "ItemSelector";
});
$p.j = (function(n) {
  switch (n) {
    case 0: {
      return this.Xf;
      break;
    }
    case 1: {
      return this.wW;
      break;
    }
    case 2: {
      return this.wT;
      break;
    }
    case 3: {
      return this.wU;
      break;
    }
    case 4: {
      return this.wV;
      break;
    }
    default: {
      throw $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
function $isArrayOf_Lpresto_ItemSelector(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.it)));
}
export { $isArrayOf_Lpresto_ItemSelector as $isArrayOf_Lpresto_ItemSelector };
var $d_Lpresto_ItemSelector = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_ItemSelector, "presto.ItemSelector", ({
  it: 1,
  b: 1,
  c: 1,
  a: 1
}));
export { $d_Lpresto_ItemSelector as $d_Lpresto_ItemSelector };
//# sourceMappingURL=presto.-Item-Selector.js.map
